import axios from 'axios';
import { EventBus } from '@/utils/eventBus.js';

// Single source of truth for backend URLs (see .env / .env.development).
export const API_URL = process.env.VUE_APP_API_URL || 'https://api.andreas-koenig.com/api';
export const MEDIA_URL = process.env.VUE_APP_MEDIA_URL || 'https://api.andreas-koenig.com';

const api = axios.create({
  baseURL: API_URL,
});

// Attach the JWT (if present) to every request.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 the token is invalid/expired: clear it and let App.vue redirect to /login.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('tokenExpire');
      EventBus.emit('recheck-auth');
    }
    return Promise.reject(error);
  }
);

export default api;
